import React, { useEffect, useState } from 'react';
import DashboardCard, { type DashboardCardSize } from 'components/DashboardCard/DashboardCard';
import { Assignment } from '@mui/icons-material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import api from 'api';
import { Link } from '@tanstack/react-router';

const pageSize = 10;

type ChartRow = {
    visit_id: number | string;
    patient_name: string;
    client_name: string;
    date_created: string;
};

export type RecentChartsProps = {
    size?: DashboardCardSize;
};

const RecentCharts = ({ size = 'md' }: RecentChartsProps) => {
    const [rows, setRows] = useState<ChartRow[]>([]);

    useEffect(() => {
        async function fetchCharts() {
            const result = await api.get('/charts/search', {
                params: {
                    page_number: 0,
                    page_size: pageSize,
                    patient_name: '',
                    client_name: '',
                },
            });

            setRows(result.data.charts);
        }

        fetchCharts().catch((err) => console.log(err));
    }, []);

    return (
        <DashboardCard
            color="deepPurple"
            icon={<Assignment />}
            topContent="Recent Dental Charts"
            topLabel={`Showing the ${rows.length} most recent reports`}
            size={size}
        >
            <div>
                <Table sx={{ width: '100%' }} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">Patient Name</TableCell>
                            <TableCell align="left">Client Name</TableCell>
                            <TableCell align="right">Chart Date</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {rows.map((row) => (
                            <TableRow key={row.visit_id}>
                                <TableCell component="th" scope="row">
                                    <Link to={`/chart/${row.visit_id}`}>{row.patient_name}</Link>
                                </TableCell>
                                <TableCell align="left">{row.client_name}</TableCell>
                                <TableCell align="right">{row.date_created}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        </DashboardCard>
    );
};

export default RecentCharts;
